import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12a4 4 0 1 0 -4 -4","key":"svg-0"}],["path",{"d":"M8 16a4 4 0 1 0 4 -4","key":"svg-1"}]]

/**
 * IconNumber3
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbnVtYmVyLTMiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEyIDEyYTQgNCAwIDEgMCAtNCAtNCIgLz4KICA8cGF0aCBkPSJNOCAxNmE0IDQgMCAxIDAgNCAtNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/number-3
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconNumber3 = createReactComponent('outline', 'number-3', 'Number3', __iconNode);

export default IconNumber3;